import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { LeftControl, RightControl } from './Controls';
import style from './styles/style.module.css';

import Carousel from './index.js';

class MiniCarousel extends PureComponent {
    constructor( props ) {
        super( props );

        this.defaultSettings = {
            slidesToShow: 3,
            slidesToScroll: 3,
            infinite: false,
            swipeToSlide: false,
            responsive: false,
            prevArrow: <LeftControl extendedClass={ style.miniLeftControl } />,
            nextArrow: <RightControl extendedClass={ style.miniRightControl } />,
        };
    }
    render() {
        var props = { ...this.props };
        props.sliderSettings = {
            ...this.defaultSettings,
            ...this.props.sliderSettings,
        };
        delete props.children;
        props.style = { height: '100%', width: '100%' };
        return (
            <Carousel { ...props } className={ style.miniCarousel }>
                { this.props.children }
            </Carousel>
        );
    }
}

export default connect()( MiniCarousel );
